import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    errorMessage: (count: number) => string | React.ReactNode;
    warningMessage: string;
    fetchDownloadAssetFailedWarning: string;
    toastTitleDrive: string;
    toastTitleTransfer: string;
    toastTitleBrowser: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "useDownloadAssets.errorMessage?c=ddzy8wfg5fgz", defaultMessage: "Couldn''t download {count, plural, other {{count} items} one {{count} item}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            warningMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDownloadAssets.warningMessage?c=2yeq6gkvctgaw", defaultMessage: "Some files could not be downloaded." }));
                },
                enumerable: true,
                configurable: true
            },
            fetchDownloadAssetFailedWarning: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDownloadAssets.fetchDownloadAssetFailedWarning?c=24ffvt3i7dc3y", defaultMessage: "Failed to fetch download asset" }));
                },
                enumerable: true,
                configurable: true
            },
            toastTitleDrive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDownloadAssets.toastTitleDrive?c=14dggm9xh2ctf", defaultMessage: "Downloading in Drive app" }));
                },
                enumerable: true,
                configurable: true
            },
            toastTitleTransfer: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDownloadAssets.toastTitleTransfer?c=2171f3mu8mkl6", defaultMessage: "Downloading in Transfer app" }));
                },
                enumerable: true,
                configurable: true
            },
            toastTitleBrowser: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDownloadAssets.toastTitleBrowser?c=31nkj5amy5xnq", defaultMessage: "Downloading in browser" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
